var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentCardId == 'confirm'),expression:"currentCardId == 'confirm'"}],staticClass:"card"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overflow-scroll-y"},[_c('div',{staticClass:"card-header confirm-header"},[_c('h2',[_vm._v("作成した志望動機書を確認")])])])
}]

export { render, staticRenderFns }